import React, { useContext, useEffect, useRef, useState } from 'react';
import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom';

import '../../index.css';
import * as XLSX from 'xlsx';
import {
  getItemList,
  getItemStatisticsByTime,
  getUserDetail,
  getMakeShopProductList,
} from '../../modules/NetworkFunction';
import { returnMessageFromCode } from '../../utils/ErrorAlertComponent';
import StatisticsModal from './StatisticsModal';
import StatisticsSelectItemModal from './StatisticsSelectItemModal';
import AuthContext from '../../contexts/AuthContext';
import ShopModeContext from '../../contexts/ShopModeContext';
import deleteIcon from '../../icons/ic-item-delete.png';
import moment from 'moment';

Chart.register(zoomPlugin);

let MultiChart;
let ctx;

const colorList = [
  '#FFB600',
  '#FF650E',
  '#FF7A00',
  '#FFA800',
  '#FFD600',
  '#ECD458',
  '#D6CB91',
  '#BCB591',
  '#9E9D93',
  '#898984',
  '#595959',
];

function MyPageStatisticsByTime() {
  const { auth: token } = useContext(AuthContext);
  const { shopMode } = useContext(ShopModeContext);

  const userNo = sessionStorage.getItem('userNo');

  const year = new Date().getFullYear(); // 년
  const month = new Date().getMonth(); // 월
  const day = new Date().getDate(); // 일
  const prevDateRef = useRef(null);
  const nextDateRef = useRef(null);

  const [date1, setDate1] = useState(new Date(year, month, day - 5));
  const [date2, setDate2] = useState(new Date(year, month, day + 1));

  const [prevDate, setPrevDate] = useState('');
  const [nextDate, setNextDate] = useState('');

  const [productList, setProductList] = useState([]);
  const [isProductLoaded, setIsProductLoaded] = useState(false);

  const [itemList, setItemList] = useState([]);
  const [isItemLoaded, setIsItemLoaded] = useState(false);
  const [selectedItemList, setSelectedItemList] = useState([]); // selected num item list
  const [isSelected, setIsSelected] = useState(false);

  const [makeshopItemList, setMakeshopItemList] = useState([]);
  const [isMakeshopItemLoaded, setIsMakeshopItemLoaded] = useState(false);

  const [excelDateList, setExcelDateList] = useState([]);
  const [excelNumList, setExcelNumList] = useState([]);

  const [noItem, setNoItem] = useState(true);
  const [drawLoading, setDrawLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectModalOpen, setSelectModalOpen] = useState(false);

  const [makeshopURL, setMakeshopURL] = useState('');

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const openSelectModal = () => {
    setSelectModalOpen(true);
    setIsSelected(false);
  };

  const closeSelectModal = () => {
    setSelectModalOpen(false);
  };

  useEffect(() => {
    prevDateRef.current.value = date1.toISOString().substring(0, 10);
    nextDateRef.current.value = date2.toISOString().substring(0, 10);

    setPrevDate(date1.toISOString().substring(0, 10));
    setNextDate(date2.toISOString().substring(0, 10));

    // 상품 목록 초기화
    setSelectedItemList([]);
    setMakeshopItemList([]);

    if (shopMode === 'cafe24') {
   
        getItemList(
          { userNo },
          (v) => {
            setItemList(v);
          },
          setIsItemLoaded,
          (e) => {
            console.log(e);
          },
          null,
          token
        );
      
    } else {
    
        getUserDetail(
          null,
          (v) => {
            console.log(v);
            
              let makeshopDomain = new URL(v?.user.makeshopURL).hostname;
              setMakeshopURL(v?.user.makeshopURL);

              getMakeShopProductList(
                {
                  shopDomain: makeshopDomain,
                  shopKey: v?.user.makeshopKey,
                },
                (data) => {
                  if (data.return_code !== '0000') { // 정상 응답이 아닌 경우
                    returnMessageFromCode(data.return_code);
                    return;
                  }
                  console.log(data.list)
                  const sortedMakeShopProductList = data.list.sort((a, b) => Number(b.view_count) - Number(a.view_count));
                  console.log(sortedMakeShopProductList)
                  setMakeshopItemList([...sortedMakeShopProductList]);
                },
                (e) => {
                  console.log(e);
                },
                token
              )
            
          },
          setIsMakeshopItemLoaded,
          (e) => {
            console.log(e)
          },
          token
        )
      
    }

  }, [token, date1, date2, shopMode, userNo, isItemLoaded, isMakeshopItemLoaded]);

  useEffect(() => {
    buildMultiChart([], true);
  }, []);

  useEffect(() => {

      ctx = document.getElementById("MultiChart").getContext("2d");
      ctx.clearRect(0, 0, 100, 100);

      buildMultiChart([], true);
  }, [shopMode, userNo, date1, date2, day, productList, isItemLoaded, isProductLoaded, itemList, token]);

  let start = Number(prevDate.split("-")[2]);
  let end = Number(nextDate.split("-")[2]);
  let dateLabels = [];
  for(let i=start; i<=end;i++){
      dateLabels.push(i+"일 심야");
      dateLabels.push(i+"일 오전");
      dateLabels.push(i+"일 오후");
      dateLabels.push(i+"일 저녁");
  
  }

  const makeExcel_getMyPageStaticsByTime = () => {
    if (selectedItemList.length === 0 || excelDateList.length === 0 || excelNumList.length === 0) {
      alert('조회된 상품이 없어 빈 엑셀 파일을 생성합니다.');
    }

    const wsData = [];

    const header = ['상품명', '날짜', '조회수'];
    wsData.push(header);

    if (selectedItemList.length === 0 || excelDateList.length === 0 || excelNumList.length === 0) {
      wsData.push(['-', '-', '-']);
    } else {
      for (let i = 0; i < excelNumList.length; i++) {
        for (let j = 0; j < excelDateList.length; j++) {
          wsData.push([
            selectedItemList[i].name,
            excelDateList[j],
            excelNumList[i][j],
          ]);
        }
      }
    }

    const worksheet = XLSX.utils.aoa_to_sheet(wsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, '시간대별 조회수');

    XLSX.writeFile(workbook, '시간대 별 상품 순위.xlsx');
  };

  let array = [];
  productList.map((p) => {
    console.log(p);
    array.push(p);
  });

  let datas = [];
  let sum = [];
  for (let i = 0; i < array.length * 4; i++) {
    sum.push(0);
  }
  array.map((p, i) => {
    let tmp = [];
    let labelName;
    for (let j = 0; j <= array.length; j++) {
      if (p[j] != 'undefined' && p[j] != null) {
        labelName = p[j].name;
        p[j].counts.map((x) => {
          tmp.push(x.count);
        });
      }
    }
    console.log(tmp);
    tmp.map((p, i) => {
      sum[i] += p;
    });
    datas.push({
      type: 'line',
      label: p[0].name,
      data: tmp,
      fill: false,
      borderColor: colorList[i],
      tension: 0.1,
    });
  });
  datas.push({
    type: 'bar',
    label: '전체 조회수',
    data: sum,
    fill: true,
    backgroundColor: '#CCCCCC',
    tension: 0.1,
  });

  const buildMultiChart = (dataArray, isDefault) => {
    let ctx = document.getElementById('MultiChart').getContext('2d');
    if (ctx) {
      ctx.clearRect(0, 0, 100, 100);
    }
    const existingChart = Chart.getChart('MultiChart');
    if (existingChart) {
      existingChart.destroy();
    }

    if (!isDefault) {
      console.log(dataArray[0]);
      console.log(dataArray[1]);
      let labelData = [];
      let countData = [];
      let totalData = [];
      let maxCount = 0;

      dataArray[0].map((subData) => {
        subData.counts.map((c, index) => {
          let month = subData.date.split('-')[1];
          let day = subData.date.split('-')[2];

          //console.log("index : " + index);
          if (index == 0) {
            console.log(month + '/' + day + '\n' + c.hourgroup);
            labelData.push(month + '/' + day + '심야');
          } else if (index == 1) {
            console.log(month + '/' + day + '\n' + c.hourgroup);
            labelData.push(month + '/' + day + '오전');
          } else if (index == 2) {
            console.log(month + '/' + day + '\n' + c.hourgroup);
            labelData.push(month + '/' + day + '오후');
          } else {
            console.log(month + '/' + day + '\n' + c.hourgroup);
            labelData.push(month + '/' + day + '저녁');
          }
        });
      });

      dataArray.map((contentsData) => {
        let clist = [];
        contentsData.map((content) => {
          let newCounts = [];
          newCounts.push(content.counts.find((c) => c.hourgroup === '심야'));
          newCounts.push(content.counts.find((c) => c.hourgroup === '오전'));
          newCounts.push(content.counts.find((c) => c.hourgroup === '오후'));
          newCounts.push(content.counts.find((c) => c.hourgroup === '저녁'));
          newCounts.map((c, index) => {
            clist.push(c.count);
            if (c.count > maxCount) maxCount = c.count;
          });
        });
        countData.push(clist);
      });

      setExcelNumList(countData);
      setExcelDateList(labelData);

      let finalData = dataArray.map((contentsData, index) => {
        let color = '#' + Math.round(Math.random() * 0xffffff).toString(16);
        return {
          type: 'line',
          label: contentsData[index].name, // 콘텐츠 이름 : title, 상품 이름 : name
          data: countData[index],
          fill: false,
          backgroundColor: color,
          borderColor: color,
          tension: 0.1,
        };
      });

      countData[0].map((c) => {
        totalData.push(0);
      });
      countData.map((arr) => {
        arr.map((a, index) => {
          totalData[index] += a;
        });
      });
      console.log(totalData);
      finalData.push({
        type: 'bar',
        label: '전체 조회수',
        data: totalData,
        fill: true,
        backgroundColor: '#CCCCCC',
        tension: 0.1,
      });
      console.log(maxCount);
      MultiChart = new Chart(ctx, {
        data: {
          labels: labelData,
          datasets: finalData,
        },
        options: {
          grouped: false,

          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              min: 0,
              max: maxCount,
            },
          },
          animation: {
            duration: 750,
          },
          plugins: {
            datalabels: {
              display: false,
            },
            legend: {
              labels: {
                usePointStyle: true,
              },
              position: 'bottom',
            },
          },
          // plugins: {
          //     zoom: {
          //         zoom: {
          //             wheel: {
          //                 enabled: true,
          //             },
          //             pinch: {
          //                 enabled: true
          //             },
          //             mode: 'xy',
          //         },
          //     }
          // }
        },
      });
    } else {
      let firstLabel = [];
      let firstData = [];

      let btMs = date2.getTime() - date1.getTime();
      let btDay = btMs / (1000 * 60 * 60 * 24);
      for (let i = btDay; i >= 0; i--) {
        let monthData = new Date(year, month, day - i).getMonth() + 1;
        let dayData = new Date(year, month, day - i).getDate();

        firstLabel.push(monthData + '/' + dayData + '심야');
        firstLabel.push(monthData + '/' + dayData + '오전');
        firstLabel.push(monthData + '/' + dayData + '오후');
        firstLabel.push(monthData + '/' + dayData + '저녁');

        firstData.push(0);
        firstData.push(0);
        firstData.push(0);
        firstData.push(0);
      }

      MultiChart = new Chart(ctx, {
        data: {
          labels: firstLabel,
          datasets: [
            {
              type: 'bar',
              label: '',
              data: firstData,
              fill: true,
              backgroundColor: '#CCCCCC',
              tension: 0.1,
            },
          ],
        },
        options: {
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              min: 0,
              max: 100,
            },
          },
          animation: {
            duration: 750,
          },
          plugins: {
            legend: {
              display: false,
            },
            datalabels: {
              display: false, // 데이터 라벨 숨기기
            },
          },
        },
      });
    }
  };

  const drawChart = () => {
    let chartNoList = [];

    selectedItemList.forEach((item) => { 
      shopMode === 'cafe24' ? chartNoList.push(item.itemNo) : chartNoList.push(parseInt(item.uid, 10));
    });

    // if (chartNoList.length == 0) {
    //   alert('원하시는 상품 선택후, 결과보기를 누르십시오');
    //   setDrawLoading(false);

    //   return;
    // } else if (prevDate === '' || nextDate === '') {
    //   alert('분석기간을 선택해 주시기 바랍니다.');
    //   setDrawLoading(false);

    //   return;
    // } else if (nextDate < prevDate) {
    //   alert('끝 날짜가 시작 날짜보다 앞서면 안됩니다.');
    //   setDrawLoading(false);

    //   return;
    // }
    // 1. 상품 선택 여부 확인
    if (chartNoList.length === 0) {
      alert('원하시는 상품 선택 후, 결과보기를 눌러주세요.');
      setDrawLoading(false);
      setNoItem(true)
      return;
    }


    let params = {
      startDate: prevDate,
      endDate: nextDate,
      itemNoList: [...chartNoList],
      shopMode,
    };
    console.log('params : ', params);

    setNoItem(false);
    setDrawLoading(true);

    getItemStatisticsByTime(
      params,
      (v) => {
        console.log(v);
        if (v.results.length > 0) {
          buildMultiChart(v.results, false);
          setDrawLoading(false);
          console.log('success');
        } else {
          setNoItem(true);
          setDrawLoading(false);
          alert('조회할 데이터가 없습니다.');
          return;
        }
      },
      setIsProductLoaded,
      (e) => {
        console.log(e);
      },
      token
    );
  };

  const eraseItem = (item) => {
    setSelectedItemList((prev) =>
      prev.filter((i) =>
        shopMode === 'cafe24' ? i.itemNo !== item.itemNo : i.uid !== item.uid
      )
    );
  };

  const showItems = () => {
    if (selectedItemList.length === 0) {
      alert('상품을 선택해주시길 바랍니다.');
    } else {
      setSelectModalOpen(false);
      setIsSelected(true);
    }
  };

  const selectItemHandler = (itemNo) => {
    console.log("selectItemHandler")
    let existingSelectedItem;

    if (shopMode === 'cafe24') {
      existingSelectedItem = selectedItemList.find(
        (item) => item.itemNo === itemNo
      );
    } else {
      existingSelectedItem = selectedItemList.find(
        (item) => item.uid === itemNo
      );
    }
    

    if (existingSelectedItem) {
      eraseItem(itemNo);
    } else {
      if (shopMode === 'cafe24') {
        setSelectedItemList((prev) => [
          ...prev,
          itemList.find((item) => item.itemNo === itemNo),
        ]);
      } else {
        setSelectedItemList((prev) => [
          ...prev,
          makeshopItemList.find((item) => item.uid === itemNo),
        ]);
      }
    }
  };

  const selectAllItemHandler = () => {
    console.log('selectAllItemHandler')
    if (selectedItemList.length === itemList.length) {
      setSelectedItemList([]);
    } else {
      if (shopMode === 'cafe24') {
        setSelectedItemList(itemList);
      } else {
        setSelectedItemList(makeshopItemList);
      }
    }
  };

  return (
    <div>
      <StatisticsModal
        open={modalOpen}
        close={closeModal}
        header="시간대별 상품 조회 순위"
      />
      {shopMode === 'cafe24' ? 
      (isItemLoaded && selectModalOpen && 
        <StatisticsSelectItemModal
          itemType={'product'}
          save={showItems}
          open={selectModalOpen}
          close={closeSelectModal}
          header="상품 선택"
          itemList={shopMode === 'cafe24' ? itemList : makeshopItemList}
          onSelectItem={selectItemHandler}
          selectedItemList={selectedItemList}
          onSelectAllItem={selectAllItemHandler}
          shopMode={shopMode}
          makeshopURL={makeshopURL}
        />) :
        (
          isMakeshopItemLoaded && selectModalOpen && 
          <StatisticsSelectItemModal
          itemType={'product'}
          save={showItems}
          open={selectModalOpen}
          close={closeSelectModal}
          header="상품 선택"
          itemList={shopMode === 'cafe24' ? itemList : makeshopItemList}
          onSelectItem={selectItemHandler}
          selectedItemList={selectedItemList}
          onSelectAllItem={selectAllItemHandler}
          shopMode={shopMode}
          makeshopURL={makeshopURL}
        />
        )
      }

      <p
        style={{
          fontSize: 30,
          fontWeight: '400',
          marginTop: '16px',
          marginBottom: '16px',
        }}
      >
        시간대별 상품 조회 순위
      </p>

      <div
        style={{
          border: '0.5px solid #848484',
          marginBottom: '40px',
          width: '788px',
        }}
      ></div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ display: 'flex', marginRight: 10 }}>
          <div
            style={{
              display: 'flex',
              width: '80px',
              height: '36px',
              background: '#CCCCCC',
              borderRadius: '10px',
              justifyContent: 'center',
              alignItems: 'center',
              fontWeight: '400',
              fontSize: '16px',
              marginRight: 12,
            }}
          >
            제품명
          </div>

          <button
            onClick={openSelectModal}
            style={{
              width: '175px',
              height: '36px',
              borderRadius: '5px',
              cursor: 'pointer',
              marginRight: '30px',
              border: 0,
              outline: 0,
              backgroundColor: 'rgba(231, 231, 231, 0.45)',
              color: '#B5B5B5',
              fontSize: 14,
            }}
          >
            상품을 선택해주세요
          </button>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div
              style={{
                display: 'flex',
                width: '80px',
                height: '36px',
                background: '#CCCCCC',
                borderRadius: '10px',
                justifyContent: 'center',
                alignItems: 'center',
                fontWeight: '400',
                fontSize: '16px',
                marginRight: 12,
              }}
            >
              분석 기간
            </div>

            {/*state이용해서 그래프 그리기*/}
            <input
              type="date"
              ref={prevDateRef}
              onChange={(event) => {
                setPrevDate(event.target.value);
              }}
              max={nextDate}
            />

            <p
              style={{
                margin: '0px 10px',
                color: '#CCCCCC',
              }}
            >
              ~
            </p>

            <input
              type="date"
              ref={nextDateRef}
              onChange={(event) => {
                setNextDate(event.target.value);
              }}
              min={prevDate}
            />
          </div>

          <div className="btn-result" onClick={drawChart}>
            결과보기
          </div>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          width: '100%',
          marginTop: '20px',
          marginBottom: '20px',
        }}
      >
        {isSelected &&
          selectedItemList.map((x) => {
            return (
              <div
                key={shopMode === 'cafe24' ? x.itemNo : x.uid}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '5px',
                  fontSize: '12px',
                  border: '1px solid #FFB600',
                  borderRadius: '48px',
                  padding: '1px 3px 1px 9px',
                  marginBottom: '5px',
                }}
              >
                <div style={{ color: '#4D4D4D' }}>{shopMode === 'cafe24' ? x.name : x.product_name}</div>
                <div
                  style={{
                    cursor: 'pointer',
                  }}
                >
                  <img
                    style={{ display: 'block' }}
                    src={deleteIcon}
                    onClick={() => eraseItem(x)}
                    alt="삭제 버튼"
                  />
                </div>
              </div>
            );
          })}
      </div>

      <div
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {noItem && (
          <div
            style={{
              position: 'absolute',
              color: '#848484',
              fontSize: '24px',
              paddingBottom: '40px',
            }}
          >
            선택한 상품이 없습니다.
          </div>
        )}

        {drawLoading && (
          <div
            style={{
              position: 'absolute',
              color: '#848484',
              fontSize: '24px',
              paddingBottom: '40px',
            }}
          >
            불러오는 중...
          </div>
        )}
        <canvas id="MultiChart" width="1000" height="400" />
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'right',
          marginTop: '20px',
        }}
      >
        <p style={{ fontSize: '14px', color: '#B5B5B5' }}>* 시간대 분류</p>
        <div style={{ width: '20px' }}></div>
        <p style={{ fontSize: '12px', color: '#B5B5B5' }}>
          {' '}
          심야 : 24 ~ 06시 오전 : 06 ~ 12시 오후 : 12 ~ 18시 저녁 : 18 ~ 24시{' '}
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'right',
          marginTop: '10px',
        }}
      >
        <p style={{ size: '2px', color: '#B5B5B5', fontSize: '12px' }}>
          {' '}
          * 그래프 밑부분의 상품 이름을 누르면 그래프에서 결과 삭제 가능{' '}
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'right',
          marginTop: '10px',
        }}
      >
        <p style={{ size: '2px', color: '#B5B5B5', fontSize: '12px' }}>
          {' '}
          * 동그라미 부분에 커서를 올리면 상세 조회수 확인 가능{' '}
        </p>
      </div>

      <div
        style={{ display: 'flex', justifyContent: 'right', marginTop: '20px' }}
      >
        <span
          style={{
            color: '#FF7A00',
            fontWeight: 'bold',
            marginTop: '10px',
            paddingRight: '10px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={openModal}
        >
          예시 결과 보기
        </span>
        <span
          style={{
            color: '#FF7A00',
            fontWeight: 'bold',
            marginTop: '10px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={() => {
            makeExcel_getMyPageStaticsByTime();
          }}
        >
          전체 내역 다운 받기
        </span>
      </div>
    </div>
  );
}

export default MyPageStatisticsByTime;
